import React from 'react'
import { UtilDevice, Bridge } from '@iskytrip/sdk'
import { Enhance } from '../vendor/enhance'

/**
 * @description 页面基类 业务页面继承时，需要重写生命周期的时候，需要执行父类方法
 * @example
 *      componentDidMount(){
 *          super.componentDidMount && super.componentDidMount()
 *          // do something
 *      }
 * @class BasePage
 * @extends {React.Component}
 */
@Enhance
class BasePage extends React.PureComponent {
	constructor(props) {
		super(props)
		//页面名
		this._pageName = ''

		// this._signalBarColorIsDark = false

		// this._hideLoadingPage = false

		// this._banRightGestures = false

		//添加bridge监听事件
		this.addBridgeListener()
	}

	/**
	 * @description 事件绑定
	 * @param {element} element 页面元素
	 * @param {string} eventName 事件
	 * @param {function} [handler=()=>{}] 处理事件
	 */
	eventHandler(element, eventName, handler = () => {}) {
		if (element.addEventListener) {
			element.addEventListener(eventName, handler, false)
		} else if (element.attachEvent) {
			element.attachEvent('on' + eventName, handler)
		} else {
			element['on' + eventName] = handler
		}
	}

	/**
	 * @description bridge回调
	 * @memberof BasePage
	 */
	addBridgeListener() {
		Bridge.pageAppear(() => {
			// this.showLoadingPage()
			//页面出现
			if (UtilDevice.isApp()) {
				this.pageAppear && this.pageAppear()
			}
			// 设置状态栏颜色,透明色
			Bridge.appSetSignalBarBackgroundColor('#00000000', (result) => {})
		})

		Bridge.pageDisAppear(() => {
			//页面消失
			if (UtilDevice.isApp()) {
				this.pageDisAppear && this.pageDisAppear()
			}
		})

		Bridge.pageGetBackParams(() => {
			if (UtilDevice.isApp()) {
				this.pageGetBackParams && this.pageGetBackParams()
			}
		})

		const array = ['/okCardPay']
		if (!UtilDevice.isApp() || array.includes(window.location.pathname)) {
			// 当前浏览器的状态属性和事件名称
			let changeState
			let visibilityChange

			if (typeof document.hidden !== 'undefined') {
				changeState = 'visibilityState'
				visibilityChange = 'visibilitychange'
			} else if (typeof document.mozHidden !== 'undefined') {
				changeState = 'mozVisibilityState'
				visibilityChange = 'mozvisibilitychange'
			} else if (typeof document.msHidden !== 'undefined') {
				changeState = 'msVisibilityState'
				visibilityChange = 'msvisibilitychange'
			} else if (typeof document.webkitHidden !== 'undefined') {
				changeState = 'webkitVisibilityState'
				visibilityChange = 'webkitvisibilitychange'
			}

			this.eventHandler(document, visibilityChange, () => {
				/**
				 * 这种判断方法, 在不同的微信版本, 有的生效有的不生效
				 * 小程序端有 reload 参数, 所以这段代码不生效也没关系
				 * 但不要注释, 或许哪个页面就用到了
				 * 但分销落地页不需要, 否则会导致安卓小程序, 领取的时候两次跳转登陆页面
				 * */
				if (['/getCoupons', '/nfrActivity'].includes(window.location.pathname)) {
					return
				}
				if (document[changeState] === 'hidden') {
					this.pageDisAppear && this.pageDisAppear()
				} else {
					this.pageAppear && this.pageAppear()
				}
			})
		}
	}

	/**
	 * @description 获取信号栏高度
	 * @abstract
	 * @param {int} height
	 * @memberof BasePage
	 */
	getSignalBarHeight(height) {}

	/**
	 * @description 获取信号栏+导航栏高度
	 * @abstract
	 * @param {int} height
	 * @memberof BasePage
	 */
	getWholeNavBarHeight(height) {}

	/** life cycle start */
	render() {
		return <></>
	}
	/** life cycle end */
}

// export default Enhance(PageEnhance(BasePage))
export default BasePage
